import { UaTraits } from '@/shared/constants/uatraits';

interface IsSubtitlesSelectEnabledProps {
    uatraits: UaTraits | undefined;
}
export const isSubtitlesSelectEnabled = ({ uatraits }: IsSubtitlesSelectEnabledProps) =>
    uatraits?.BrowserName === 'Chrome' ||
    uatraits?.BrowserName === 'Edge' ||
    uatraits?.BrowserName === 'Firefox';
